import {
  BTC,
  ETH,
  LTC,
  USDT,
  XRP,
  BCH,
  IRT,
  LINK,
  UNI,
  AAVE,
  TRX,
  DAI
} from "./icons";
import { __t } from "@core/translation/translation";

export const CURRENCY = {
  TYPE: {
    BTC: {
      NAME: __t("Bitcoin"),
      ICON: BTC,
      COLOR: "#fa973a",
      UNIT: "BTC",
      IR_MARKET: "BTC_IRT",
      USDT_MARKET: "BTC_USDT",
      MARKETS: {
        IRT: "BTC_IRT",
        USDT: "BTC_USDT"
      },
      SYMBOLS: {
        IRT: "BTCIRT",
        USDT: "BTCUSDT"
      }
    },
    ETH: {
      NAME: __t("Ether"),
      ICON: ETH,
      COLOR: "#757576",
      UNIT: "ETH",
      IR_MARKET: "ETH_IRT",
      USDT_MARKET: "ETH_USDT",
      MARKETS: {
        IRT: "ETH_IRT",
        USDT: "ETH_USDT"
      },
      SYMBOLS: {
        IRT: "ETHIRT",
        USDT: "ETHUSDT"
      }
    },
    LTC: {
      NAME: __t("Litecoin"),
      ICON: LTC,
      COLOR: "#bababa",
      UNIT: "LTC",
      IR_MARKET: "LTC_IRT",
      USDT_MARKET: "LTC_USDT",
      MARKETS: {
        IRT: "LTC_IRT",
        USDT: "LTC_USDT"
      },
      SYMBOLS: {
        IRT: "LTCIRT",
        USDT: "LTCUSDT"
      }
    },
    USDT: {
      NAME: __t("Tether"),
      ICON: USDT,
      COLOR: "#50c979",
      UNIT: "USDT",
      IR_MARKET: "USDT_IRT",
      USDT_MARKET: "USDT_USDT",
      MARKETS: {
        IRT: "USDT_IRT",
        USDT: ""
      },
      SYMBOLS: {
        IRT: "USDTIRT",
        USDT: ""
      }
    },
    XRP: {
      NAME: __t("Ripel"),
      ICON: XRP,
      COLOR: "#1f67ef",
      UNIT: "XRP",
      IR_MARKET: "XRP_IRT",
      USDT_MARKET: "XRP_USDT",
      MARKETS: {
        IRT: "XRP_IRT",
        USDT: "XRP_USDT"
      },
      SYMBOLS: {
        IRT: "XRPIRT",
        USDT: "XRPUSDT"
      }
    },
    BCH: {
      NAME: __t("Bitcoin cash"),
      ICON: BCH,
      COLOR: "#ee8c28",
      UNIT: "BCH",
      IR_MARKET: "BCH_IRT",
      USDT_MARKET: "BCH_USDT",
      MARKETS: {
        IRT: "BCH_IRT",
        USDT: "BCH_USDT"
      },
      SYMBOLS: {
        IRT: "BCHIRT",
        USDT: "BCHUSDT"
      }
    },
    LINK: {
      NAME: __t("Chain-link"),
      ICON: LINK,
      COLOR: "#2a59da",
      UNIT: "LINK",
      IR_MARKET: "LINK_IRT",
      USDT_MARKET: "LINK_USDT",
      MARKETS: {
        IRT: "LINK_IRT",
        USDT: "LINK_USDT"
      },
      SYMBOLS: {
        IRT: "LINKIRT",
        USDT: "LINKUSDT"
      }
    },
    AAVE: {
      NAME: __t("Aave"),
      ICON: AAVE,
      COLOR: "#0f9ecb",
      UNIT: "AAVE",
      IR_MARKET: "AAVE_IRT",
      USDT_MARKET: "AAVE_USDT",
      MARKETS: {
        IRT: "AAVE_IRT",
        USDT: "AAVE_USDT"
      },
      SYMBOLS: {
        IRT: "AAVEIRT",
        USDT: "AAVEUSDT"
      }
    },
    UNI: {
      NAME: __t("Uni"),
      ICON: UNI,
      COLOR: "#ff007a",
      UNIT: "UNI",
      IR_MARKET: "UNI_IRT",
      USDT_MARKET: "UNI_USDT",
      MARKETS: {
        IRT: "UNI_IRT",
        USDT: "UNI_USDT"
      },
      SYMBOLS: {
        IRT: "UNIIRT",
        USDT: "UNIUSDT"
      }
    },
    TRX: {
      NAME: __t("Tron"),
      ICON: TRX,
      COLOR: "#ff060a",
      UNIT: "TRX",
      IR_MARKET: "TRX_IRT",
      USDT_MARKET: "TRX_USDT",
      MARKETS: {
        IRT: "TRX_IRT",
        USDT: "TRX_USDT"
      },
      SYMBOLS: {
        IRT: "TRXIRT",
        USDT: "TRXUSDT"
      }
    },
    DAI: {
      NAME: __t("Dai"),
      ICON: DAI,
      COLOR: "#f5ac37",
      UNIT: "DAI",
      MARKETS: {
        IRT: "DAI_IRT",
        USDT: ""
      },
      SYMBOLS: {
        IRT: "DAIIRT",
        USDT: ""
      }
    },
    IRT: {
      NAME: __t("toman"),
      ICON: IRT,
      COLOR: "#ff3636",
      UNIT: "IRT",
      IR_MARKET: "IRT_IRT",
      MARKETS: {
        IRT: "",
        USDT: ""
      },
      SYMBOLS: {
        IRT: "",
        USDT: ""
      }
    }
  }
};

export const DEFAULT_CURRENCIES = [
  CURRENCY.TYPE.BTC,
  CURRENCY.TYPE.ETH,
  CURRENCY.TYPE.XRP,
  CURRENCY.TYPE.USDT,
  CURRENCY.TYPE.LTC,
  CURRENCY.TYPE.TRX,
  CURRENCY.TYPE.LINK,
  CURRENCY.TYPE.AAVE,
  CURRENCY.TYPE.UNI
];

export const DEFAULT_MARKETS = {
  IRT: "IRT",
  USDT: "USDT",
  CAD: "CAD",
  t: {
    IRT: __t("toman"),
    USDT: __t("Tether"),
    CAD: "CAD",
  }
};

export const COINS_MFD = 9;
